<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Transmisión</h1>

      <hr/>
      
      <p class="texto-primario">La Red Nacional de Transmisión (RNT) es un sistema integrado por un conjunto de redes eléctricas que son utilizadas para transportar energía eléctrica desde las centrales generadoras a las redes generales de distribución y al público en general, así como las interconexiones a los sistemas eléctricos extranjeros que determine la Secretaría de Energía. Las líneas de transmisión tienen diferentes niveles de tensión es decir niveles de fuerza con que los electrones se desplazan en un circuito eléctrico y se mide en voltios. Los niveles de tensión de las líneas de transmisión van desde 69 kV a 400 kV.</p>

      </div>
      <div class="container">
    
      
        
      <dai-tarjeta-contenedor-mapa :permitir-colapso="true">
      <DaiMapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
          <DaiCapaXyz  id="Mapa" :visible="capa_prendida==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

          <DaiCapaXyz  id="Satélite" :visible="capa_prendida==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

          <DaiCapaGeojson 
          id="lineas_transmision"
          titulo="Líneas de transmisión"
          :zoom-al-dar-click="false"
          :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.Nombre}<br><b>Voltaje:</b> ${feat.voltaje_la}`"
          url="../geodata/electricidad/lineas_transmision_operacion_mayo2022.geojson"
          :reglas-estilo-capa="{
            clasificacion:'categorias',
            columna : 'voltaje_la',
            acomodoCategorias:['400 kV','230 kV','35 a 161 kV'],
            propiedadObjetivo: 'relleno',
            colores:['#0d2bd7','#e9950d','#dd1dfa']
          }"
          :estilo-capa="{
            stroke:{color:'gray',width:1}
            }"
          />

          <DaiCapaGeojson 
          id="lineas_transmision_proyecto"
          titulo="Líneas de transmisión en proyecto"
          :zoom-al-dar-click="false"
          :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.Nombre}<br><b>Empresa:</b> ${feat.Empresa}<br><b>Tipo:</b> ${feat.Tipo}<br><b>Longitud:</b> ${feat.Longitud_k}<br><b>Voltaje:</b> ${feat.voltaje_la}`"
          url="../geodata/electricidad/lineas_transmision_proyecto_mayo2022.geojson"
          :reglas-estilo-capa="{
            clasificacion:'categorias',
            columna : 'voltaje_la',
            acomodoCategorias:['400 kV','230 kV','69 a 161 kV'],
            propiedadObjetivo: 'relleno',
            colores:['#0d2bd7','#e9950d','#dd1dfa']
          }"
          :estilo-capa="{
            stroke:{color:'gray',width:1, lineDash: [2,4]}
            }"
          />

         

          <DaiCapaGeojson 
            id="subestaciones_cfe"
            titulo="Subestaciones"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.Name}<br><b>Fase:</b> ${feat.Fase}<br><b>Voltaje (Kv):</b> ${feat.Voltaje_KV}`"
            url="../geodata/electricidad/subestaciones_cfe.json"
            :estilo-capa="{circle:{fill:{color:'#006e4c'},stroke:{color:'white'},radius:2}}"
          />

          </DaiMapa>

          <template v-slot:header>
              <h2 v-width-control="'100%'">Red Nacional de Transmisión</h2>

              <p v-width-control="'50%'" >Red Naciónal de Transmisión (RNT), líneas de transmisión en protyecto y subestaciones eléctricas.</p> 

              <dai-interruptor-mapa v-width-control="'50%'"
              v-model="capa_prendida"
              :opciones="['Mapa','Satélite']"
              /> 
              <br/>

              <dai-leyenda-mapa
              titulo="Red Nacional de Transmisión (RNT)"
              :para="['lineas_transmision']"
              />
              

              <br>
              <dai-leyenda-mapa
              titulo="Líneas de transmisión en proyecto"
              :para="['lineas_transmision_proyecto']"
              />

              <dai-leyenda-mapa
              titulo="Subestaciones eléctricas (CFE)"
              :para="['subestaciones_cfe']"
              />
          </template>
      </dai-tarjeta-contenedor-mapa>

      <br>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Nivel de tensión por centro de control regional (KV)</h3>
          <p class="texto-notas">Fuente:  PRODESEN 2019-2033.</p>
          <p class="texto-secundario">El Sistema Eléctrico Nacional está organizado por nueve regiones de control. En esta gráfica se representa el porcentaje de los niveles de tensión para cada centro de control regional.</p>
        </div>
        <div class="contenido">
          <div class="graficaNivelTension" ref="graficaNivelTension">
        </div>
        </div>
      </div>

      <br>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Longitud por Gerencia de Transmisión</h3>
          <p class="texto-notas">Año 2018. Fuente: PRODESEN 2019-2033.</p>
        </div>
        <div class="contenido">
          <div class="graficaLongitudGerenciaTransmision" ref="graficaLongitudGerenciaTransmision">
        </div>
        </div>
      </div>

      <br>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Longitud por nivel de tensión</h3>
          <p class="texto-notas">Año 2018. Fuente: PRODESEN 2019-2033.</p>
        </div>
        <div class="contenido">
          <div class="graficaLongitudNivelTension" ref="graficaLongitudNivelTension">
        </div>
        </div>
      </div>

      </div>
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h2 class="titulo m-t-2 m-t-3-md">Pérdidas por distribución</h2>
      <hr>
      <p class="texto-primario">Las pérdidas de energía en la empresa CFE Distribución están integradas por Pérdidas Técnicas y Pérdidas no Técnicas y, su volumen, se calcula a partir de la energía recibida, restando la energía entregada.</p>
      <p class="texto-primario">Las <b>pérdidas técnicas</b> se refieren a que debido al calentamiento de los conductores eléctricos y transformadores por la saturación de las redes de distribución se pierde electricidad.</p>
      <p class="texto-primario">Las <b>pérdidas no técnicas</b> se refieren al uso ilícito de la energía o a los daños provocados por estos usos, lo que genera errores administrativos y pérdidas eléctricas.</p>
      <p class="texto-primario">Las pérdidas de energía eléctrica por razones de distribución representaron el 15% de la energía generada en 2019 y el 19% en 2020. En 2020, la generación de energía eléctrica a partir de fuentes eólica y solar alcanzó el 10.6% de la generación total. Por lo que se pierde más energía por razones de distribución que lo que se generó por las fuentes renovables. Existen planes para mejorar las redes de transmisión eléctrica, sin embargo, se debe cuestionar si invertir en la transmisión de larga distancia (siendo México un país con 2 millones de km2) o si mejor fomentar proyectos de Generación distribuida. La generación distribuida se refiere a una variedad de tecnologías que generan electricidad a proximidad de los lugares donde se utilizará por medio de centrales con capacidad instalada inferior a 0.5 MW instalada como paneles solares y calor y electricidad combinados.</p>
      </div>
      <div class="container">

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Pérdidas técnicas y no técnicas por Centro de Control Regional</h3>
          <p class="texto-notas">Datos para 2020. Información generada por PLANEAS a partir de datos de CENACE.</p>
        </div>
        <div class="encabezado">
          <div class="graficaPerdidasCentroRegional" ref="graficaPerdidasCentroRegional"></div>
        </div>
        <!--<div class="notas">
          <div class="contenedor"></div>
          <button class="boton-notas">Más información</button>
        </div>-->
      </div>

      <br>

      <dai-tarjeta-contenedor-mapa :permitir-colapso="false" >
        <template v-slot:header>
            
            <h2>Pérdidas técnicas y no técnicas por municipio (MWh)</h2>

            <dai-selector-mapa 
            v-model="selModalidad"
            class="control-large" 
            >
                <option value="tecnicas">Pérdidas técnicas</option>
                <option value="no_tecnicas">Pérdidas no técnicas</option>
            </dai-selector-mapa>

            <dai-leyenda-mapa v-show="selModalidad==='tecnicas'"
            titulo="Pérdidas técnicas por municipio"
            :para="['perdidas_tecnicas_2020']"
            />

            <br>
            <dai-leyenda-mapa v-show="selModalidad==='no_tecnicas'"
            titulo="Pérdidas no técnicas por municipio"
            :para="['perdidas_no_tecnicas_2020']"
            />
            
        </template>
        <dai-mapa
        :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
        >
          
          <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


          <dai-capa-geojson :visible="selModalidad==='tecnicas'"
            id="perdidas_tecnicas_2020"
            titulo="Pérdidas técnicas por nodo 2020 (MWh)"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.mun}<br><b>Pérdidas técnicas:</b> ${feat.per}`"
            url="../geodata/electricidad/perdidas_tecnicas_2020.geojson"
            :estilo-capa="{
            circle:{
                fill:{color:'#333'},
                stroke:{color:'#DDD',width:1},
                radius:3
              }
            }"
            :reglas-estilo-capa="[
            {
              clasificacion:'cuantiles',
              columna: 'per',
              propiedadObjetivo:'relleno',
              colores:['#118dff','#70bbff','#cfe8ff','#f7dadc','#e68f96','#d64550'],
              clases:6,
              tituloVariable:'Promedio de pérdidas técnicas MWh'
            }
            ]"
          />

          <dai-capa-geojson :visible="selModalidad==='no_tecnicas'"
            id="perdidas_no_tecnicas_2020"
            titulo="Pérdidas no técnicas por municipio 2020 (MWh)"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.mun}<br><b>Pérdidas no técnicas:</b> ${feat.per}`"
            url="../geodata/electricidad/perdidas_no_tecnicas_2020.geojson"
            :reglas-estilo-capa="[
            {
                clasificacion:'linear',
                columna: 'per',
                propiedadObjetivo:'proporcion',
                proporciones:[3,5,6,10,15],
                clases:5,
                tituloVariable:'Promedio de pérdidas no técnicas MWh'
            },
            {
              clasificacion:'cuantiles',
              columna: 'per',
              propiedadObjetivo:'relleno',
              colores:['#118dff','#70bbff','#cfe8ff','#f7dadc','#e68f96','#d64550'],
              clases:6,
              tituloVariable:'Promedio de pérdidas no técnicas MWh'
            }
            ]"
          />


          </dai-mapa>

          <template v-slot:footer>
            <p class="texto-notas">Datos para 2020. Información generada por PLANEAS a partir de datos de CENACE.</p>
          </template>
          
      </dai-tarjeta-contenedor-mapa>
      
      <hr>
      <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
          <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
          <ul class="lista-referencias">
            <li><em><strong>Centro Nacional de Control de Energía (CENACE) (s.f).</strong></em><em>&nbsp;</em> Programa de Ampliación y Modernización de la RNT y RGD 2022 - 2036. <a href="https://www.cenace.gob.mx/Docs/10_PLANEACION/ProgramasAyM/Programa%20de%20Ampliaci%C3%B3n%20y%20Modernizaci%C3%B3n%20de%20la%20RNT%20y%20RGD%202022%20-%202036.pdf" target="_blank" rel="noopener">https://www.cenace.gob.mx/Docs/10_PLANEACION/ProgramasAyM/Programa%20de%20Ampliaci%C3%B3n%20y%20Modernizaci%C3%B3n%20de%20la%20RNT%20y%20RGD%202022%20-%202036.pdf</a></li>
            <li><em><strong>Centro Nacional de Control de Energía (CENACE) (s.f.).</strong></em> Estimación de Pérdidas Reales. Consultado en febrero 2021. <a href="https://www.cenace.gob.mx/Paginas/SIM/Reportes/EstimacionPerdidasReales.aspx" target="_blank">https://www.cenace.gob.mx/Paginas/SIM/Reportes/EstimacionPerdidasReales.aspx</a></li>
            <li><em><strong>Geocomunes (2022).&nbsp;</strong></em>L&iacute;neas de Transmisions en Proyecto en M&eacute;xico. Fecha publicaci&oacute;n: Mayo de 2022. Recuperado en 10 febrero 2023.&nbsp;<a href="http://www.google.com/url?q=http%3A%2F%2F132.248.14.102%2Flayers%2FCapaBase%3Alt_proyecto1&amp;sa=D&amp;sntz=1&amp;usg=AFQjCNGecJ62xv8wQu38c4ZLv4ZvZPUTmA" target="_blank" rel="noopener">http://132.248.14.102/layers/CapaBase:lt_proyecto1</a></li>
            <li><em><strong>Programa de Desarrollo del Sistema El&eacute;ctrico Nacional 2019-2033 (PRODESEN) (s.f).&nbsp;</strong></em>&nbsp;Recuperado en octubre de 2020.&nbsp;<a href="https://www.google.com/url?q=https%3A%2F%2Fwww.gob.mx%2Fsener%2Farticulos%2Fprodesen-2019-2033-221654&amp;sa=D&amp;sntz=1&amp;usg=AFQjCNH4c2He-_i5znT8d_FfKxqLEkji6A" target="_blank" rel="noopener">https://www.gob.mx/sener/articulos/prodesen-2019-2033-221654</a></li>
            <li><em><strong>Secretaría de Energía SENER (2022).</strong></em> Programa para el Desarrollo del Sistema Eléctrico Nacional 2019-2033. Recuperado en octubre de 2019. <a href="https://www.gob.mx/sener/articulos/prodesen-2019-2033-221654" target="_blank">https://www.gob.mx/sener/articulos/prodesen-2019-2033-221654</a></li>
          </ul>
      </div>

    </div>
  </div>
</template>

<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
      
    },
    data:function(){
        return {
            capa_prendida:'Mapa',
            perdidasCentroRegional: perdidasCentroRegional,
            selModalidad:'tecnicas',
        }
    },
    mounted() {
        let chartNivelTension = am4core.create(this.$refs.graficaNivelTension, am4charts.XYChart);
        chartNivelTension.language.locale = am4lang_es_ES;
        chartNivelTension.language.locale["_decimalSeparator"] = ".";
        chartNivelTension.language.locale["_thousandSeparator"] = ",";
        chartNivelTension.exporting.menu = new am4core.ExportMenu();
        chartNivelTension.exporting.filePrefix = "NivelTensionElectricidad";
        chartNivelTension.exporting.useWebFonts = false;
        chartNivelTension.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chartNivelTension.fontSize = 13;

      chartNivelTension.data = [
      {
        "34": 0,
        "69": 2829,
        "85": 0,
        "115": 3105,
        "138": 0,
        "161": 2898,
        "230": 4830,
        "400": 0,
        "centro": "BAJA CALIFORNIA"
      },
      {
        "34": 0,
        "69": 0,
        "85": 0,
        "115": 3220,
        "138": 0,
        "161": 0,
        "230": 230,
        "400": 0,
        "centro": "BAJA CALIFORNIA SUR"
      },
      {
        "34": 0,
        "69": 276,
        "85": 9095,
        "115": 6670,
        "138": 0,
        "161": 0,
        "230": 20240,
        "400": 1200,
        "centro": "CENTRAL"
      },
      {
        "34": 0,
        "69": 0,
        "85": 0,
        "115": 21505,
        "138": 7176,
        "161": 0,
        "230": 5520,
        "400": 7600,
        "centro": "NORESTE"
      },
      {
        "34": 0,
        "69": 0,
        "85": 0,
        "115": 20815,
        "138": 0,
        "161": 0,
        "230": 4370,
        "400": 800,
        "centro": "NOROESTE"
      },
      {
        "34": 0,
        "69": 0,
        "85": 0,
        "115": 28060,
        "138": 0,
        "161": 0,
        "230": 3680,
        "400": 400,
        "centro": "NORTE"
      },
      {
        "34": 0,
        "69": 6969,
        "85": 0,
        "115": 63710,
        "138": 0,
        "161": 322,
        "230": 8510,
        "400": 4000,
        "centro": "OCCIDENTAL"
      },
      {
        "34": 0,
        "69": 828,
        "85": 765,
        "115": 56005,
        "138": 0,
        "161": 0,
        "230": 4830,
        "400": 4000,
        "centro": "ORIENTAL"
      },
      {
        "34": 102,
        "69": 0,
        "85": 0,
        "115": 10810,
        "138": 0,
        "161": 0,
        "230": 690,
        "400": 0,
        "centro": "PENINSULAR"
      }
    ];

      chartNivelTension.colors.step = 2;
      chartNivelTension.padding(30, 30, 10, 30);
      chartNivelTension.legend = new am4charts.Legend();
      chartNivelTension.legend.useDefaultMarker = true;
      let markerNivelTension = chartNivelTension.legend.markers.template.children.getIndex(0);
      markerNivelTension.cornerRadius(12, 12, 12, 12);
      markerNivelTension.strokeWidth = 2;
      markerNivelTension.strokeOpacity = 1;
      markerNivelTension.stroke = am4core.color("#fff");

      var categoryAxis = chartNivelTension.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "centro";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.renderer.labels.template.wrap = true;
      categoryAxis.renderer.labels.template.maxWidth = 120;
      categoryAxis.renderer.minGridDistance = 1;

      var valueAxis = chartNivelTension.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;
      valueAxis.calculateTotals = true;
      valueAxis.renderer.minWidth = 50;
      valueAxis.renderer.labels.template.adapter.add("text", function(text) {
          return text + "%";
      });

      function createSeriesNivelTension(field, name, color) {
        var series = chartNivelTension.series.push(new am4charts.ColumnSeries());
        series.columns.template.width = am4core.percent(80);
        series.columns.template.tooltipText =
          "Nivel de tensión: {name} - {valueY.totalPercent.formatNumber('#.00')}%";
        series.name = name;
        series.dataFields.categoryX = "centro";
        series.dataFields.valueY = field;
        series.dataFields.valueYShow = "totalPercent";
        series.dataItems.template.locations.categoryX = 0.5;
        series.stacked = true;
        series.tooltip.pointerOrientation = "vertical";

      }

      createSeriesNivelTension('34','34kV','#333333');
      createSeriesNivelTension('69','69kV','#333333');
      createSeriesNivelTension('85','85kV','#333333');
      createSeriesNivelTension('115','115kV','#333333');
      createSeriesNivelTension('138','138kV','#333333');
      createSeriesNivelTension('161','161kV','#333333');
      createSeriesNivelTension('230','230kV','#333333');
      createSeriesNivelTension('400','400kV','#333333');

      this.chartNivelTension = chartNivelTension;

      let chartLongitudGerenciaTransmision = am4core.create(this.$refs.graficaLongitudGerenciaTransmision, am4charts.XYChart);
      chartLongitudGerenciaTransmision.language.locale = am4lang_es_ES;
      chartLongitudGerenciaTransmision.language.locale["_decimalSeparator"] = ".";
      chartLongitudGerenciaTransmision.language.locale["_thousandSeparator"] = ",";
      chartLongitudGerenciaTransmision.exporting.menu = new am4core.ExportMenu();
      chartLongitudGerenciaTransmision.exporting.filePrefix = "LongitudGerenciaTransmision";
      chartLongitudGerenciaTransmision.exporting.useWebFonts = false;
      chartLongitudGerenciaTransmision.fontSize = 12;

      chartLongitudGerenciaTransmision.data = [{
        "name": "Baja California",
        "value": 5195
      }, {
        "name": "Noroeste",
        "value": 13097
      }, {
        "name": "Norte",
        "value": 12508
      }, {
        "name": "Noreste",
        "value": 11061
      }, {
        "name": "Occidente",
        "value": 19663
      }, {
        "name": "Central",
        "value": 17753
      }, {
        "name": "Oriente",
        "value": 12142
      }, {
        "name": "Sureste",
        "value": 9556
      }, {
        "name": "Peninsular",
        "value": 7052
      }
      ];

      /*var seriesLongGerenciaTrans = chartLongitudGerenciaTransmision.series.push(new am4charts.PictorialStackedSeries());
      seriesLongGerenciaTrans.dataFields.value = "value";
      seriesLongGerenciaTrans.dataFields.category = "name";
      seriesLongGerenciaTrans.alignLabels = true;
      seriesLongGerenciaTrans.orientation = "horizontal";
      seriesLongGerenciaTrans.maskSprite.path = "M 6 8 L 20 8 L 20 10 L 6 10";*/
    
      chartLongitudGerenciaTransmision.padding(40, 40, 40, 40);

      let categoryAxisLongitudGerenciaTransmision = chartLongitudGerenciaTransmision.yAxes.push(new am4charts.CategoryAxis());
      categoryAxisLongitudGerenciaTransmision.renderer.grid.template.location = 0;
      categoryAxisLongitudGerenciaTransmision.dataFields.category = "name";
      categoryAxisLongitudGerenciaTransmision.renderer.minGridDistance = 1;
      categoryAxisLongitudGerenciaTransmision.renderer.inversed = true;
      categoryAxisLongitudGerenciaTransmision.renderer.grid.template.disabled = true;

      let valueAxisLongitudLineaTransmision = chartLongitudGerenciaTransmision.xAxes.push(new am4charts.ValueAxis());
      valueAxisLongitudLineaTransmision.min = 0;

      let seriesLongitudGerenciaTransmision = chartLongitudGerenciaTransmision.series.push(new am4charts.ColumnSeries());
      seriesLongitudGerenciaTransmision.dataFields.categoryY = "name";
      seriesLongitudGerenciaTransmision.dataFields.valueX = "value";
      seriesLongitudGerenciaTransmision.tooltipText = "{valueX.value}"
      seriesLongitudGerenciaTransmision.columns.template.strokeOpacity = 0;

      let labelBulletGerenciaTransmision = seriesLongitudGerenciaTransmision.bullets.push(new am4charts.LabelBullet())
      labelBulletGerenciaTransmision.label.horizontalCenter = "left";
      labelBulletGerenciaTransmision.label.dx = 10;
      labelBulletGerenciaTransmision.label.text = "{values.valueX.workingValue.formatNumber('#,###.#')} km";
      labelBulletGerenciaTransmision.locationX = 1;

      
      seriesLongitudGerenciaTransmision.columns.template.adapter.add("fill", function(fill, target){
        return chartLongitudGerenciaTransmision.colors.getIndex(target.dataItem.index);
      });

      categoryAxisLongitudGerenciaTransmision.sortBySeries = seriesLongitudGerenciaTransmision;

      chartLongitudGerenciaTransmision.cursor = new am4charts.XYCursor();

      this.chartLongitudGerenciaTransmision = chartLongitudGerenciaTransmision;


      //Longitud por nivel de tension
      let chartLongitudNivelTension = am4core.create(this.$refs.graficaLongitudNivelTension, am4charts.XYChart);
      chartLongitudNivelTension.language.locale = am4lang_es_ES;
      chartLongitudNivelTension.language.locale["_decimalSeparator"] = ".";
      chartLongitudNivelTension.language.locale["_thousandSeparator"] = ",";
      chartLongitudNivelTension.exporting.menu = new am4core.ExportMenu();
      chartLongitudNivelTension.exporting.filePrefix = "LongitudNivelTension";
      chartLongitudNivelTension.exporting.useWebFonts = false;
      chartLongitudNivelTension.fontSize = 12;

      chartLongitudNivelTension.data = [{
        "name": "400 kV",
        "value": 25455
      }, {
        "name": "230 KV",
        "value": 29115
      }, {
        "name": "69 a 161  KV",
        "value": 53448
      }
      ];

    
      chartLongitudNivelTension.padding(40, 40, 40, 40);

      let categoryAxisLongitudNivelTension = chartLongitudNivelTension.yAxes.push(new am4charts.CategoryAxis());
      categoryAxisLongitudNivelTension.renderer.grid.template.location = 0;
      categoryAxisLongitudNivelTension.dataFields.category = "name";
      categoryAxisLongitudNivelTension.renderer.minGridDistance = 1;
      categoryAxisLongitudNivelTension.renderer.inversed = true;
      categoryAxisLongitudNivelTension.renderer.grid.template.disabled = true;

      let valueAxisLongitudNivelTension = chartLongitudNivelTension.xAxes.push(new am4charts.ValueAxis());
      valueAxisLongitudNivelTension.min = 0;

      let seriesLongitudNivelTension = chartLongitudNivelTension.series.push(new am4charts.ColumnSeries());
      seriesLongitudNivelTension.dataFields.categoryY = "name";
      seriesLongitudNivelTension.dataFields.valueX = "value";
      seriesLongitudNivelTension.tooltipText = "{valueX.value}"
      seriesLongitudNivelTension.columns.template.strokeOpacity = 0;

      let labelBulletNivelTension = seriesLongitudNivelTension.bullets.push(new am4charts.LabelBullet())
      labelBulletNivelTension.label.horizontalCenter = "left";
      labelBulletNivelTension.label.dx = 10;
      labelBulletNivelTension.label.text = "{values.valueX.workingValue.formatNumber('#,###.#')} km";
      labelBulletNivelTension.locationX = 1;

      seriesLongitudNivelTension.columns.template.adapter.add("fill", function(fill, target){
        return chartLongitudNivelTension.colors.getIndex(target.dataItem.index);
      });

      categoryAxisLongitudNivelTension.sortBySeries = seriesLongitudNivelTension;

      chartLongitudNivelTension.cursor = new am4charts.XYCursor();

      this.chartLongitudNivelTension = chartLongitudNivelTension;


      //Grafica Pérdidas
      var chartPerdidas = am4core.create(this.$refs.graficaPerdidasCentroRegional, am4charts.XYChart)
      chartPerdidas.language.locale = am4lang_es_ES;
      chartPerdidas.language.locale["_decimalSeparator"] = ".";
      chartPerdidas.language.locale["_thousandSeparator"] = ",";
      chartPerdidas.exporting.menu = new am4core.ExportMenu();
      chartPerdidas.exporting.filePrefix = "PerdidasElectricidad";
      chartPerdidas.exporting.useWebFonts = false;
      chartPerdidas.colors.step = 2;

      chartPerdidas.legend = new am4charts.Legend();
      chartPerdidas.legend.useDefaultMarker = true;
      chartPerdidas.legend.position = 'bottom';
      chartPerdidas.legend.paddingBottom = 20;
      chartPerdidas.legend.fontSize = 12;
      let markerPerdidas = chartPerdidas.legend.markers.template.children.getIndex(0);
      markerPerdidas.cornerRadius(12, 12, 12, 12);
      markerPerdidas.strokeWidth = 2;
      markerPerdidas.strokeOpacity = 1;
      markerPerdidas.stroke = am4core.color("#fff");
      //chart.legend.labels.template.maxWidth = 95

      var xAxis = chartPerdidas.xAxes.push(new am4charts.CategoryAxis());
      xAxis.dataFields.category = 'centro_control_reg';
      xAxis.renderer.cellStartLocation = 0.1;
      xAxis.renderer.cellEndLocation = 0.9;
      xAxis.renderer.grid.template.location = 0;
      xAxis.renderer.minGridDistance = 1;
      xAxis.renderer.fontSize = 11;

      var yAxis = chartPerdidas.yAxes.push(new am4charts.ValueAxis());
      yAxis.min = 0;
      yAxis.renderer.fontSize = 11;
      yAxis.renderer.labels.template.adapter.add("text", function(text) {
        return text + " MWh";
      });

      function createSeriesPerdidas(value, name, color) {
          var series = chartPerdidas.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = value;
          series.dataFields.categoryX = 'centro_control_reg';
          series.name = name;
          series.fill = am4core.color(color);

          series.events.on("hidden", arrangeColumns);
          series.events.on("shown", arrangeColumns);

          series.tooltip = new am4core.Tooltip();
          series.tooltipHTML = "<br>"+name+": {valueY} MWh";

          
          return series;
      }

      chartPerdidas.data = perdidasCentroRegional;
      
      chartPerdidas.cursor = new am4charts.XYCursor();

      createSeriesPerdidas('perdidas_tecnicas', 'Pérdidas técnicas', '#118dff');
      createSeriesPerdidas('perdidas_no_tecnicas', 'Pérdidas no técnicas', '#12239e');

      this.chartPerdidas = chartPerdidas;

      function arrangeColumns() {

          var series = chartPerdidas.series.getIndex(0);

          var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
          if (series.dataItems.length > 1) {
              var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
              var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
              var delta = ((x1 - x0) / chart.series.length) * w;
              if (am4core.isNumber(delta)) {
                  var middle = chartPerdidas.series.length / 2;

                  var newIndex = 0;
                  chartPerdidas.series.each(function(series) {
                      if (!series.isHidden && !series.isHiding) {
                          series.dummyData = newIndex;
                          newIndex++;
                      }
                      else {
                          series.dummyData = chartPerdidas.series.indexOf(series);
                      }
                  })
                  var visibleCount = newIndex;
                  var newMiddle = visibleCount / 2;

                  chartPerdidas.series.each(function(series) {
                      var trueIndex = chartPerdidas.series.indexOf(series);
                      var newIndex = series.dummyData;

                      var dx = (newIndex - trueIndex + middle - newMiddle) * delta

                      series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                      series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                  })
              }
          }
      }

    },
    beforeDestroy() {
      if (this.chartNivelTension) {
        this.chartNivelTension.dispose();
      }

      if(this.chartLongitudNivelTension) {
        this.chartLongitudNivelTension.dispose();
      }

      if (this.chartLongitudGerenciaTransmision) {
        this.chartLongitudGerenciaTransmision.dispose();
      }
      if(this.chartPerdidas) {
        this.chartPerdidas.dispose();
      }

    },
  }


  const perdidasCentroRegional = [
  {
    "centro_control_reg": "OCCIDENTAL",
    "perdidas_tecnicas": 3251758,
    "perdidas_no_tecnicas": 2383879.22
  },
  {
    "centro_control_reg": "ORIENTAL",
    "perdidas_tecnicas": 2814653,
    "perdidas_no_tecnicas": 2591328.35
  },
  {
    "centro_control_reg": "CENTRAL",
    "perdidas_tecnicas": 2611056,
    "perdidas_no_tecnicas": 4800698.2
  },
  {
    "centro_control_reg": "NORESTE",
    "perdidas_tecnicas": 1698196,
    "perdidas_no_tecnicas": 1866113.31
  },
  {
    "centro_control_reg": "NORTE",
    "perdidas_tecnicas": 1163026,
    "perdidas_no_tecnicas": 1140222.51
  },
  {
    "centro_control_reg": "NOROESTE",
    "perdidas_tecnicas": 777439,
    "perdidas_no_tecnicas": 996715.75
  },
  {
    "centro_control_reg": "PENINSULAR",
    "perdidas_tecnicas": 537662,
    "perdidas_no_tecnicas": 560064.49
  },
  {
    "centro_control_reg": "BC",
    "perdidas_tecnicas": 492649,
    "perdidas_no_tecnicas": 457461.2
  },
  {
    "centro_control_reg": "BCS",
    "perdidas_tecnicas": 97848,
    "perdidas_no_tecnicas": 90859.65
  }
];

</script>

<style scoped lang="scss">
  .graficaNivelTension
  {
    width: 100%;
    height: 500px;
  }

  .graficaLongitudGerenciaTransmision
  {
    width: 100%;
    height: 400px;
  }

  .graficaLongitudNivelTension
  {
    width: 100%;
    height: 300px;
  }

      
  .graficaPerdidasCentroRegional
  {
      width: 100%;
      height: 400px;
  }

</style>
